import {Form,Card,Button,message} from 'antd'
import { useCallback, useEffect, useState } from 'react';
import ReactQuill from "react-quill";
import { useParams,useLocation,useHistory } from 'react-router-dom'
import InstituteService from '../../../../services/InstituteService';
export default function InstituteInformationForm() {
    const location=useLocation();
    const history= useHistory();
    const params= useParams();
    const [form] = Form.useForm();
    
    const [list,setList]=useState()
    const instituteID=params?.id;
    const actionForm= params?.option
      
      const updateInformationInstitute=useCallback((dataInformation)=>{
        InstituteService.updateInstituteDataByInstitute(instituteID,dataInformation).then((res)=>{
            message.success("Actualización de la información exitosa");
            history.goBack();
        })
      })
      const createInformationInstitute=useCallback((dataInformation)=>{
        InstituteService.createInstituteDataByCenter(instituteID,dataInformation).then((res)=>{
            message.success("Registro de la información exitosa");
            history.goBack();
        })
      })
    
      const onFinish=()=>{
        console.log(actionForm)
        var dataInformation=form.getFieldsValue()
        console.log(dataInformation)
        form.resetFields()
        if(actionForm==="create"){
            createInformationInstitute(dataInformation)
        }
        if (actionForm==="update") {
            updateInformationInstitute(dataInformation)
        }
      }
    useEffect(()=>{
        setList(location.state?.list);
    },[list])

    

    const listFormItems=(listOp)=>{
        let listItems=[]
        listOp?.forEach(item => {
            form.setFieldValue(item.key,item.data)
            listItems.push(
                <Form.Item
                name={item.key}
                label={item.label}
                >
                    <div>
                        <ReactQuill
                        key={"RQ"+item.key}
                        value={actionForm==="update"?item.data:""}
                        onChange={(e)=>form.setFieldValue(item.key,e)}
                        />
                    </div>
                </Form.Item>
            )
        });
        return listItems;
    }
    return(
        <>
        <Card
        style={{margin:30}}
        >
            {console.log("list",list)}
            <Form
            form={form}
            preserve={true}
            onFinish={onFinish}
            >
                {listFormItems(list)}
            </Form>
            <Card>
                <Button 
                key={"createBtn"}
                style={{
                    margin: '0 8px',
                    }}
                type='Submit' 
                onClick={()=>form.submit()}
                >
                    {actionForm==="create"?"Crear":"Actualizar"}
                </Button>
                <Button
                key={"updateBtn"}
                style={{
                margin: '0 8px',
                }}
                onClick={() => {history.goBack()}}
                >
                    Cancelar
                </Button>
            </Card>
        </Card>
       </>
    )
}